function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "System-Admin",
  transform: "translate(-810.000000, -506.000000)",
  fill: "#000000",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "Group-14",
  transform: "translate(814.000000, 519.500000) rotate(-90.000000) translate(-814.000000, -519.500000) translate(800.500000, 515.500000)"
}, React.createElement("path", {
  d: "M16.6499605,4.29351926 L21.4066035,7.45196166 C21.6381215,7.60927872 21.9117338,7.35515117 21.8275454,7.05261837 L21.3750329,5.4552452 L26.2053407,5.4552452 C26.3631939,5.4552452 26.5,5.31002946 26.5,5.11640847 L26.5,2.87766576 C26.5,2.69614608 26.3737174,2.53882903 26.2053407,2.53882903 L21.3750329,2.53882903 L21.8275454,0.941455858 C21.9117338,0.651024373 21.6381215,0.396896823 21.4066035,0.542112565 L16.6499605,3.71265628 C16.4500132,3.84577072 16.4500132,4.16040483 16.6499605,4.29351926 Z",
  id: "Path",
  transform: "translate(21.500000, 4.000000) scale(-1, 1) translate(-21.500000, -4.000000) "
}))));

var SvgUpMove = function SvgUpMove(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "8px",
    height: "11px",
    viewBox: "0 0 8 11",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgUpMove, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/up-move.7c1d722c.svg";
export { ForwardRef as ReactComponent };